import { remoteJSON } from './remote';

export const sendEmailVerification = async () => {
	const response = (await remoteJSON('/verification/email', { method: 'POST' })) as VerificationResponse;

	return response;
};

export const sendMobileVerification = async () => {
	const response = (await remoteJSON('/verification/phone?type=sms', { method: 'POST' })) as VerificationResponse;

	return response;
};

export const confirmMobileCode = async (code: string) => {
	const response = (await remoteJSON(`/verification/phone/${code}`, { method: 'POST' })) as ConfirmMobileCodeResponse;

	return response;
};

export const greenIdVerification = async () => {
	const response = await remoteJSON(`/verification/id`, { method: 'POST'});

	return response;
};

export const idComplyVerification = async () => {
	return await remoteJSON('/verification/id', { method: 'POST' });
};

export const getRegisterId = async () => {
	const response = await remoteJSON('/verification/registerId', { method: 'POST' }) as  RegisterIDResponse
	return response
}